import React, { useEffect, useState } from "react";
import "./Reviews.scss";
import axios from "axios";
import { API_URL } from "../../Config/constant";
import InputField from "../InputField/InputField";
import Button from "../Button/Button";
import ReactStars from "react-rating-stars-component";
import { CircularProgress } from "@material-ui/core";
import { getAProduct } from "../../api/products.api";

const Reviews = ({ id }) => {
  const [review, setReview] = useState("");
  const [rating, setRating] = useState(0);
  const [rvws, setRvws] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [showFullLoading, setFullShowLoading] = useState(false);

  const getData = async () => {
    setFullShowLoading(true);
    const product = await getAProduct(id);
    setRvws(product.reviews);
    setFullShowLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const add = async () => {
    if (review.length) {
      setShowLoading(true);
      const datatoSend = rvws;
      datatoSend.unshift({ msg: review, rating });
      const res = await axios.post(`${API_URL}/products/add-review/${id}`, {
        reviews: datatoSend,
      });
      if (res.data.success) {
        setReview("");
        setRating(0);
        await getData();
        setShowLoading(false);
      }
      setShowLoading(false);
    }
  };

  const getRatingMsg = () => {
    switch (rating) {
      case 0:
        return "";
      case 1:
        return "I Hate it.";
      case 2:
        return "I Didn't like it.";
      case 3:
        return "It was OK.";
      case 4:
        return "It was Really Good.";
      case 5:
        return "I Loved it.";
    }
  };

  return (
    <div className="Reviews">
      <h2>Reviews</h2>

      <div className="reviews">
        {!showFullLoading ? (
          rvws.map((rvw) => (
            <div className="review">
              <ReactStars
                count={5}
                size={24}
                value={rvw.rating}
                edit={false}
                activeColor="#ffd700"
              />
              <p>{rvw.msg}</p>
            </div>
          ))
        ) : (
          <div className="loading">
            <CircularProgress size={50} />
          </div>
        )}
      </div>
      <div className="add-review">
        <ReactStars
          count={5}
          onChange={(newRating) => {
            setRating(newRating);
          }}
          size={50}
          value={rating}
          activeColor="#ffd700"
        />
        <p>{getRatingMsg()}</p>

        <InputField
          placeholder="Describe your Experience"
          value={review}
          textarea
          onChange={(e) => setReview(e.target.value)}
        />
        <Button showLoading={showLoading} onClick={add} text="Submit" />
      </div>
    </div>
  );
};

export default Reviews;
